import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedChevronRightMdRegularIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 10, height: 24, viewBox: '0 0 10 24', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M9.344 11.656a.53.53 0 0 1 0 .719l-6 6a.53.53 0 0 1-.719 0 .53.53 0 0 1 0-.719L8.281 12 2.625 6.375a.53.53 0 0 1 0-.719.53.53 0 0 1 .719 0z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: 'de53659cc0751e42def721e02aaa5770__a' },
            React.createElement("path", { d: 'M0 0h10v24H0z' })))));
const ForwardRef = forwardRef(LabelPairedChevronRightMdRegularIcon);
export default ForwardRef;
